import { Component, Input, OnInit } from '@angular/core';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-lifecycle-action-text',
  templateUrl: './lifecycle-action-text.component.pug',
  styleUrls: ['./lifecycle-action-text.component.scss'],
  standalone: false
})
export class LifecycleActionTextComponent implements OnInit {
  @Input() check: any;
  text = '';
  xrefUnlock = false;
  xrefUnlockTooltip = '';

  constructor(
    private permissionsService : PermissionsService
  ) {
  }

  ngOnInit(): void {
    this.getActionText(this.check);
  }

  getActionText(check) {
    if (check.action == "xref created") {
      this.text = this.getCreatedActionText(check)
    } else if (check.action == "review") {
      this.text = $localize`Reviewed`;
    } else if (check.action == "submitted") {
      if (check.user_type == ConstantsService.USERTYPE_REFEREE) {
        if (check.action_arg1 == "referee" && check.action_arg3 == "confirmed") {
          this.text = this.text = $localize`Confirmed`;
        } else {
          this.text = $localize`Answered`;
        }
      }
      else if (check.user_type == ConstantsService.USERTYPE_CANDIDATE && check.action_arg1 !== "") {
        this.text = this.getSentRefereeActionText(check)
      }
    }
    else if (check.action == "xref shared") {
      this.text = $localize`Shared reference with ${check.action_arg3}`
    } else if (check.action == "autodeclined") {
      this.text = $localize`Unobtainable`;
    } else if (check.action == "xref unlock") {
      this.xrefUnlock = true;
      this.xrefUnlockTooltip = $localize`Replace reference for ${check.action_arg1} ${check.action_arg2}. Reason: Low quality reference.`;
    } else if (check.action == "unusual activity marked suspicious") {
      this.text = $localize`Marked reference as suspicious`;
    } else if (check.action == "unusual activity marked valid") {
      this.text = $localize`Marked reference as valid`;
    } else if (check.action == "notified") {
      this.text = $localize`Notified`;
    } else if (check.action == "agreed") {
      this.text = $localize`Agreed`;
    } else if (check.action == "accessed") {
      this.text = this.getAccessedActionText(check)
    } else if (check.action == "verified") {
      this.text = $localize`Verified`;
    } else if (check.action == "declined") {
      this.text = $localize`Declined`;
    } else if (check.action == "xref bulk created") {
      this.text = this.getBulkCreatedActionText()
    } else if (check.action == "unusual activity detected") {
      this.text = this.getUnusualActivityActionText()
    }else if (check.action == "replaced referee"){
      this.text = this.getReplacedRefereeText(check);
    } else if (check.action == "candidate sms consent confirmed") {
      this.text = $localize`Confirmed candidate's consent for SMS`;
    } else if (check.action == "referee sms consent confirmed") {
      this.text = $localize`Confirmed ${check.action_arg1}'s consent for SMS`;
    } else {
      const dynamicKey = `${check.action[0].toUpperCase() + check.action.slice(1)}`;
      this.text = $localize`${dynamicKey}`;
    }
  }

  getCreatedActionText(check:any){
    let text = $localize`Sent request via email`;
    if (check.action_arg3 == "email, sms") text = $localize`Sent request via email and SMS`
    return text;
  }

  getAccessedActionText(check:any){
    let text = $localize`Accessed via email`;
    if (check.action_arg3 == "sms") text = $localize`Accessed via SMS`;
    return text;
  }

  getReplacedRefereeText(check:any){
    const refereeName= JSON.parse(check.action_arg3)
    return $localize`Replaced referee ${refereeName?.referee_first_name} ${refereeName?.referee_last_name}`;
  }

  getBulkCreatedActionText(){
    return $localize`Sent bulk request`;
  }

  getUnusualActivityActionText(){
    return $localize`Unusual activity detected`;
  }

  getSentRefereeActionText(check:any){
    let text = $localize`Sent request to ${check.action_arg1} via email`;
    if (check.action_arg3 == "email, sms") text = $localize`Sent request to ${check.action_arg1} via email and SMS`;
    return text;
  }

}
